module.exports = __webpack_public_path__ + "img/error.d2e604c4.png";